import { useState, useContext, useMemo } from 'react'

import {
  SanityBlogPostWithoutBody,
  SanityBlogPostOptions,
} from '@data/sanity/queries/types/blog'
import { StringsContext } from '@lib/strings'

// import BlogPostCard from '@blocks/blog/blog-post-card'
import BlogPostListItem from '@blocks/blog/blog-post-list-item'
import Button, { ButtonVariant } from '@components/buttons/button'

interface BlogPostGridProps {
  posts: SanityBlogPostWithoutBody[]
  options?: SanityBlogPostOptions
  paginationLimit?: number
}

const BlogPostGrid = ({
  posts,
  options,
  paginationLimit = 9,
}: BlogPostGridProps) => {
  const strings = useContext(StringsContext)

  const [postEndIndex, setPostEndIndex] = useState(paginationLimit - 1)

  const hasMore = posts && posts.length > postEndIndex
  const hasPagination = paginationLimit > 0
  const postsList = useMemo(() => {
    if (!hasPagination) {
      return posts
    }

    return [...posts.slice(0, postEndIndex)]
  }, [hasPagination, postEndIndex, posts])

  const loadMore = () => {
    if (hasMore) {
      setPostEndIndex(
        (currentPostEndIndex) => currentPostEndIndex + paginationLimit
      )
    }
  }

  return (
    <section className="container">
      <div className="grid grid-cols-1 gap-y-12 mb-20">
        {postsList.map((post) => (
          <BlogPostListItem
            key={`post-${post.slug}`}
            post={post}
            options={options}
          />
        ))}
      </div>

      {hasPagination && hasMore && (
        <div className="relative py-4 sm:py-8 text-center">
          {hasMore && (
            <Button onClick={loadMore} variant={ButtonVariant.FILLED}>
              {strings.buttonLoadMore}
            </Button>
          )}
        </div>
      )}
    </section>
  )
}

export default BlogPostGrid
